import React from 'react'
import { t } from '../../i18n/i18n'
import { GridItem } from '../common/grid/GridItem'
import { Role, UserAccount } from '../../api/schemas/schema'
import { UseFormReturn } from 'react-hook-form'
import { ControlledTextInput, TextInput } from '../common/inputs/TextInput'
import { translateEnumValue } from '../../helpers/enumHelper'
import { ControlledPhoneInput } from '../common/inputs/ControlledPhoneInput'
// import { ControlledPersonalNumberInput } from '../common/inputs/ControlledPersonalNumberInput'

type ModalAccountInformationProps = {
   userAccountForm: UseFormReturn<UserAccount, any, UserAccount>
}

export const ModalAccountInformationForm = ({ userAccountForm }: ModalAccountInformationProps) => {
   const { control } = userAccountForm
   return (
      <>
         <GridItem size={'6/12'}>
            <ControlledTextInput required name={'firstName'} label={t('FirstName')} control={control} disabled />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledTextInput required name={'lastName'} label={t('LastName')} control={control} disabled />
         </GridItem>
         {/* <GridItem size={'12/12'}>
            <ControlledPersonalNumberInput required name={'personalNumber'} label={t('PersonalIdentityNumber')} control={control} />
         </GridItem> */}
         <GridItem size={'6/12'}>
            <ControlledTextInput required name={'email'} label={t('Email')} control={control} type="email" />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledPhoneInput control={control} name={'phoneNumber'} label={t('PhoneNumber')} />
         </GridItem>

         <GridItem size={'12/12'}>
            <TextInput label={t('Roles')} value={translateEnumValue(Role, userAccountForm.getValues('role'))} disabled />
         </GridItem>
      </>
   )
}
